export default __webpack_public_path__ + "implementation-stage-timeline-section.png";